import { BaseApiClient } from './base'

export class LibraryApi extends BaseApiClient {
  async getPopularBooks(filters?: { genre?: string; limit?: number }): Promise<{ books: any[] }> {
    const params = new URLSearchParams()
    if (filters?.genre) params.append('genre', filters.genre)
    if (filters?.limit) params.append('limit', filters.limit.toString())
    
    const queryString = params.toString()
    return this.request(`/library/popular${queryString ? `?${queryString}` : ''}`)
  }

  async getLibraryBooks(filters?: { search?: string; language?: string; genre?: string; grade?: string; page?: number; page_size?: number }): Promise<{ books: any[]; pagination?: any }> {
    const params = new URLSearchParams()
    if (filters?.search) params.append('search', filters.search)
    if (filters?.language) params.append('language', filters.language)
    if (filters?.genre) params.append('genre', filters.genre)
    if (filters?.grade) params.append('grade', filters.grade)
    if (filters?.page) params.append('page', filters.page.toString())
    if (filters?.page_size) params.append('page_size', filters.page_size.toString())
    
    const queryString = params.toString()
    return this.request(`/library/books${queryString ? `?${queryString}` : ''}`)
  }

  async getLibraryBook(bookId: string): Promise<{ book: any }> {
    return this.request(`/library/books/${bookId}`)
  }

  async downloadLibraryBook(bookId: string, translationId: string): Promise<void> {
    return this.downloadFile(`/library/books/${bookId}/download/${translationId}`, 'book')
  }

  async downloadLibraryBookOriginal(bookId: string): Promise<void> {
    return this.downloadFile(`/library/books/${bookId}/download-original`, 'book_original')
  }

  async getTopLanguages(): Promise<{ top_languages: string[] }> {
    return this.request('/library/top-languages')
  }
}

